import Button from 'Components/Button'
import { FC } from 'react'
import styled from 'styled-components'
import { theme } from 'styles/theme'
import { useTranslation } from 'react-i18next'
import { ReinforcementDescription, ReinforcementTitle } from './Typography'

interface ReinforcementOverlayProps {
  title: JSX.Element
  description: JSX.Element
  onNext: () => void
}

export const ReinforcementOverlayBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.mediumLarge};
  gap: ${props => props.theme.spacing.small};
  border-radius: 32px;
  background-color: rgba(255, 255, 255, 0.88);
  max-width: 390px;
  margin-top: auto;
  opacity: 1;
  transform: translateY(0px);
`

const ReinforcementOverlay: FC<ReinforcementOverlayProps> = ({
  title,
  description,
  onNext
}) => {
  const { t } = useTranslation()

  return (
    <ReinforcementOverlayBox>
      <ReinforcementTitle>
        {title}
      </ReinforcementTitle>
      <ReinforcementDescription>
        {description}
      </ReinforcementDescription>
      <Button onClick={onNext} primaryColor={theme.colors.primary} margin="10px 0 0 0">
        {t('continueButton')}
      </Button>
    </ReinforcementOverlayBox>
  )
}
export default ReinforcementOverlay
